/* eslint-disable no-useless-concat */
/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import PopupInput from "../Inputs/PopupInput/PopupInput";
import { logEvent, shareByMail } from "../../utils/api/api";
import CustomPopup from "../CustomPopup/CustomPopup";
import {
  selectRetrofitCurrentStep,
  selectEmailData,
  selectShowEmailPopup,
  setShowEmailPopup,
  setStoredEmailData,
  showSnackbar
} from "../../../Retrofit/store/slices/retrofit";
import t from "../../utils/translation/translator";
import {
  selectConfigurationType,
  selectEventsData,
  selectLocale,
  selectSeamlessSession
} from "../../store/slices/common";
import { selectCartesianCurrentStep } from "../../../Cartesian/store/slices/cartesian";
import { selectMc12CurrentStep } from "../../../Mc12/store/slices/mc12";

const EmailPopup = ({ configId, configType }) => {
  const showEmailPopup = useSelector(selectShowEmailPopup);

  const [currentTab, setCurrentTab] = useState(1);
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const emailDataFromRedux = useSelector(selectEmailData);
  const configurationType = useSelector(selectConfigurationType);
  const seamlessSession = useSelector(selectSeamlessSession);

  const defaultEmailData = {
    captchaResponse: null,
    linkToTool: window.location.href,
    message: null,
    recipientEmail: null,
    recipientName: null,
    senderEmail: seamlessSession?.email || emailDataFromRedux?.senderEmail,
    senderName: seamlessSession?.name || emailDataFromRedux?.senderName,
    subject: "Schneider Electric" + " " + t("msizer.ui.motion-configurator"),
    tool: configType ? configType : configurationType
  };

  const [emailData, setEmailData] = useState({ ...defaultEmailData });
  const [validEmailData, setValidEmailData] = useState(false);

  useEffect(() => {
    // setValidEmailData if all values are filled
    if (
      (emailData.recipientEmail || currentTab === 1) &&
      (emailData.recipientName || currentTab === 1) &&
      emailData.senderEmail &&
      emailData.senderName &&
      emailData.subject &&
      emailData.captchaResponse &&
      emailData.tool
    ) {
      setValidEmailData(true);
    } else {
      setValidEmailData(false);
    }
  }, [emailData]);

  const handleExecShareByMail = () => {
    dispatch(setStoredEmailData(emailData));
    // eslint-disable-next-line no-use-before-define
    execShareByMail();
  };

  const eventsData = useSelector(selectEventsData);
  const retrofitCurrentStep = useSelector(selectRetrofitCurrentStep);
  const cartesianCurrentStep = useSelector(selectCartesianCurrentStep);
  const mc12CurrentStep = useSelector(selectMc12CurrentStep);
  let currentStep = retrofitCurrentStep;
  if (configurationType === "CARTESIAN") {
    currentStep = cartesianCurrentStep;
  } else if (configurationType === "MC12") {
    currentStep = mc12CurrentStep;
  }

  const {
    refetch: execShareByMail,
    isLoading,
    isFetching
  } = useQuery(
    "send by mail",
    async () => {
      try {
        logEvent(
          eventsData.locale,
          currentTab === 1 ? eventsData.types.sendMail : eventsData.types.shareMail,
          currentStep.id === 1 ? eventsData.tags.startPage : eventsData.tags.finalizeStep,
          configId
        );

        const sentmail = await shareByMail({
          emailData,
          configId
        });
        // console.log("sentmail", sentmail);
        dispatch(setShowEmailPopup(false));
        dispatch(showSnackbar({ id: "EMAIL_SENT" }));
        setEmailData({ ...defaultEmailData });
        return sentmail;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, configId);
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    setEmailData(defaultEmailData);
  }, [currentTab, showEmailPopup]);

  const locale = useSelector(selectLocale);
  // language is what before the "-" in the locale
  const lang = locale.split("-")[0];

  // Recaptcha language
  const languageMappings = {
    ar: "ar",
    af: "af",
    am: "am",
    hy: "hy",
    az: "az",
    eu: "eu",
    bn: "bn",
    bg: "bg",
    ca: "ca",
    "zh-HK": "zh-HK",
    "zh-CN": "zh-CN",
    "zh-TW": "zh-TW",
    hr: "hr",
    cs: "cs",
    da: "da",
    nl: "nl",
    "en-GB": "en-GB",
    en: "en",
    et: "et",
    fil: "fil",
    fi: "fi",
    fr: "fr",
    "fr-CA": "fr-CA",
    gl: "gl",
    ka: "ka",
    de: "de",
    de_at: "de_at",
    "de-ch": "de-ch",
    el: "el",
    gu: "gu",
    iw: "iw",
    hi: "hi",
    hu: "hu",
    is: "is",
    id: "id",
    it: "it",
    ja: "ja",
    kn: "kn",
    ko: "ko",
    lo: "lo",
    lv: "lv",
    lt: "lt",
    ms: "ms",
    ml: "ml",
    mr: "mr",
    mn: "mn",
    non: "non",
    fa: "fa",
    pl: "pl",
    pt: "pt",
    "pt-BR": "pt-BR",
    "pt-PT": "pt-PT",
    ro: "ro",
    ru: "ru",
    sr: "sr",
    si: "si",
    sk: "sk",
    sl: "sl",
    es: "es",
    "es-419": "es-419",
    sw: "sw",
    sv: "sv",
    ta: "ta",
    te: "te",
    th: "th",
    tr: "tr",
    uk: "uk",
    ur: "ur",
    vi: "vi",
    zu: "zu"
  };

  const hl = languageMappings[lang] || "en"; // Set language based on mapping, default to English if language is not found

  return (
    <CustomPopup
      headerTitle={t("msizer.ui.popup.mail.title")}
      opened={showEmailPopup}
      onClose={() => dispatch(setShowEmailPopup(false))}
      isEmailPopup
      cancelAction={() => dispatch(setShowEmailPopup(false))}
    >
      <div className="flex flex-col space-y-5">
        <div className="text-left text-gray-800 text-xxs">
          <div className="flex mx-5 text-xs">
            <span
              id="popup-email-tab-1"
              className={`border-[1px] border-gray-200 border-solid flex-1 p-3  font-semibold text-center hover:bg-gray-100 cursor-pointer transition-all duration-75 ${
                currentTab === 1 ? "bg-gray-10 border-b-2 border-b-primary text-primary" : "bg-white text-gray-800"
              }`}
              onClick={() => setCurrentTab(1)}
            >
              {t("msizer.ui.popup.mail.tabs.send_to_me")}
            </span>
            <span
              id="popup-email-tab-2"
              className={`border-[1px] border-gray-200 border-solid flex-1 p-3  font-semibold text-center hover:bg-gray-100 cursor-pointer transition-all duration-75 ${
                currentTab === 2 ? "bg-gray-10 border-b-2 border-b-primary text-primary" : "bg-white text-gray-800"
              }`}
              onClick={() => setCurrentTab(2)}
            >
              {t("msizer.ui.popup.mail.tabs.send_to_someone_else")}
            </span>
          </div>
          {currentTab === 1 && (
            <div className="flex flex-col space-y-2 p-4 bg-gray-5 border-t">
              <span className="font-semibold">{t("msizer.ui.popup.mail.send_to_me.text1")}</span>
              <span className="font-semibold">{t("msizer.ui.popup.mail.send_to_me.text2")}</span>
              <div className="space-y-2">
                <PopupInput
                  id="popup-email-sender-name"
                  type="text"
                  value={emailData.senderName || emailDataFromRedux?.senderName || ""}
                  onChange={(e) => {
                    setEmailData({
                      ...emailData,
                      senderName: e.target.value
                    });
                  }}
                  label={t("msizer.ui.popup.mail.name")}
                  required
                />
                <PopupInput
                  id="popup-email-sender-mail"
                  type="email"
                  value={emailData.senderEmail || emailDataFromRedux?.senderEmail || ""}
                  onChange={(e) => {
                    setEmailData({
                      ...emailData,
                      senderEmail: e.target.value
                    });
                  }}
                  label={t("msizer.ui.popup.mail.email")}
                  required
                />
              </div>
              {/* <div className="flex space-x-3 items-center">
                <input
                  type="checkbox"
                  className="focus:ring-0 cursor-pointer checked:bg-secondary
"
                />
                <span className="">
                  I&apos;d like to receive news and commercial info from
                  Schneider Electric and its affiliates via electronic
                  communication means such as email. For more details, please
                  read our{" "}
                  <a
                    href="https://www.se.com/ww/en/about-us/legal/data-privacy.jsp"
                    target="_blank"
                    className=" text-secondary
 hover:underline"
                    rel="noreferrer"
                  >
                    Privacy Policy.
                  </a>
                </span>
              </div> */}
              <div className="pt-2">
                <ReCAPTCHA
                  sitekey="6LcXB6gZAAAAAAj_lkQ84kDKeDNwbwhqWtBb6f_1"
                  onChange={(value) => {
                    console.log(value);
                    setEmailData({
                      ...emailData,
                      captchaResponse: value
                    });
                  }}
                  hl={hl}
                />
              </div>
            </div>
          )}
          {currentTab === 2 && (
            <div className="flex flex-col space-y-2 p-4 bg-gray-5 border-t">
              <span className="font-semibold">{t("msizer.ui.popup.mail.send_to_someone_else.text1")}</span>
              <span className="font-semibold">{t("msizer.ui.popup.mail.send_to_someone_else.text2")}</span>
              <div className="space-y-2">
                <div className="grid grid-cols-2 space-x-4">
                  <PopupInput
                    id="popup-email-sender-name"
                    type="text"
                    value={emailData?.senderName || emailDataFromRedux?.senderName || ""}
                    onChange={(e) => {
                      setEmailData({
                        ...emailData,
                        senderName: e.target.value
                      });
                    }}
                    label={t("msizer.ui.popup.mail.name")}
                    required
                  />
                  <PopupInput
                    id="popup-email-sender-mail"
                    type="email"
                    value={emailData?.senderEmail || emailDataFromRedux?.senderEmail || ""}
                    onChange={(e) => {
                      setEmailData({
                        ...emailData,
                        senderEmail: e.target.value
                      });
                    }}
                    label={t("msizer.ui.popup.mail.email")}
                    required
                  />
                </div>
                <div className="grid grid-cols-2 space-x-4">
                  <PopupInput
                    id="popup-email-recipient-name"
                    type="text"
                    value={emailData?.recipientName || ""}
                    onChange={(e) => {
                      setEmailData({
                        ...emailData,
                        recipientName: e.target.value
                      });
                    }}
                    label={t("msizer.ui.popup.mail.recipient_name")}
                    required
                  />
                  <PopupInput
                    id="popup-email-recipient-mail"
                    type="email"
                    value={emailData?.recipientEmail || ""}
                    onChange={(e) => {
                      setEmailData({
                        ...emailData,
                        recipientEmail: e.target.value
                      });
                    }}
                    label={t("msizer.ui.popup.mail.recipient_email")}
                    required
                  />
                </div>
                <PopupInput
                  id="popup-email-message"
                  value={emailData?.message || ""}
                  onChange={(e) => {
                    setEmailData({
                      ...emailData,
                      message: e.target.value
                    });
                  }}
                  label={t("msizer.ui.popup.mail.message")}
                  inputType="textarea"
                />
              </div>
              <div className="pt-2">
                <ReCAPTCHA
                  sitekey="6LcXB6gZAAAAAAj_lkQ84kDKeDNwbwhqWtBb6f_1"
                  onChange={(value) => {
                    console.log(value);
                    setEmailData({
                      ...emailData,
                      captchaResponse: value
                    });
                  }}
                  hl={hl}
                />
              </div>
            </div>
          )}
          <div className="p-4 pt-0 space-y-3 bg-gray-5 select-none">
            <div className="flex space-x-4">
              <qds-button
                id="popup-email-button-cancel"
                onClick={() => dispatch(setShowEmailPopup(false))}
                class="flex-1"
                text={t("msizer.ui.popup.button.cancel")}
              ></qds-button>
              <qds-button
                id="popup-email-button-send"
                importance="emphasized"
                {...(!validEmailData || isFetching || isLoading ? { disabled: "" } : {})}
                onClick={handleExecShareByMail}
                class="flex-1"
                text={t("msizer.ui.send_by_mail")}
              ></qds-button>
            </div>
          </div>
        </div>
      </div>
    </CustomPopup>
  );
};

EmailPopup.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  configId: PropTypes.any.isRequired
};

export default EmailPopup;
